import React, { useEffect, useState } from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import downArrow from "../../../assets/svg/downarrow.svg";
import Pagination from "react-js-pagination";
import upArrow from "../../../assets/svg/uparrow.svg";
import Autocomplete from "react-autocomplete";
import UserRole from "../../../helpers/role";
import FileIcon from "../documents/folder/FileIcon";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import moment from "moment";
import Filter from "../../../assets/svg/filter.svg";
import infoBlack from "../../../assets/svg/infoBlack.svg";
import Select from "react-select";
import search from "../../../assets/svg/search.svg";
import WarningIcon from "../../../assets/svg/warningIcon.svg";
import { PulseLoader } from "react-spinners";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import calender from "../../../assets/svg/calender.svg";
import ButtonSubmitIcon from "../../../assets/svg/submitbuttonIcon.svg";
import ButtonCancelRequestIcon from "../../../assets/svg/buttoncancelrequestIcon.svg";
import ButtonUnobsoleteIcon from "../../../assets/svg/unobsoleteIcon.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg";
import MyRequestIcon from "../../../assets/svg/myactionmax.svg";
import CompletedTaskIcon from "../../../assets/svg/completedtaskmax.svg";
import URLIcon from "../../../assets/svg/urlIcon.svg";
import dateIcon from "../../../assets/svg/calendar-inside.svg";
import URLworldIcon from "../../../assets/svg/urlworldIcon.svg";
import API from "../../../helpers/endpointService";
import axios from "axios";
import NotesIcon from "../../../assets/svg/notesIcon.svg";
import DateFnsUtils from "@date-io/date-fns";
import NewPropertiesIcon from "../../../assets/svg/propertiesicon.svg";
import VersionIcon from "../../../assets/svg/versionlog.svg";
import AssignIcon from "../../../assets/svg/assignedtoIcon.svg";
import SubCategoryIcon from "../../../assets/svg/smallcategory.svg";
import DownArrowIcon from "../../../assets/svg/downarrow.svg";
import UpArrowIcon from "../../../assets/svg/uparrow.svg";
import LeftArrowIcon from "../../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../../assets/svg/RightArrow.svg";
import CrossIcon from "../../../assets/svg/crossIcon.svg";
import PPTIcon from "../../../assets/svg/MyrequestdocumentIcon.svg";
import DateIcon from "../../../assets/svg/date.svg";
import SearchFileIcon from "../../../assets/svg/Filesearch.svg";
import file from "../../../assets/svg/File.svg";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import $ from "jquery";
import { logoutFunction } from "../../custom/commonFunction";

const paginglist = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
];
const paginglistDefault = [{ label: "20", value: 20 }];

var SelectedValue = false;
var SelectedValueSearch = false;
var closeNewSearch = false;

class MyRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "",
      currentUser: "",
      isRequestFailed: false,
      isRequestLoader: false,
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isCancelMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      myrequestsList: undefined,
      versionLogList: [],
      approvefileurlList: [],
      currentPage: 1,
      approver1Error: false,
      checker1Error: false,
      approver2Error: false,
      checker2Error: false,
      consultant1Error: false,
      consultant2Error: false,
      openauthorList: false,
      opencategory1List: false,
      opencategory2List: false,
      perPage: 20,
      totalCount: 0,
      requestCount: 0,
      currentPage: 1,
      historyLogList: [],
      approvedocumentsList: [],
      documentNumber: "",
      myrequestView: {
        id: 0,
        documentName: "",
        revisedDocumentId: 0,
        documentNo: "",
        version: 0,
        category1Name: "",
        category2Name: "",
        category1Id: 0,
        category2Id: 0,
        authorId: 0,
        authorName: "",
        checker1Id: 0,
        checker2Id: 0,
        checker1Name: "",
        checker2Name: "",
        consultant1Id: 0,
        consultant2Id: 0,
        consultant1Name: "",
        consultant2Name: "",
        approver1Id: 0,
        approver2Id: 0,
        approver1Name: "",
        approver2Name: "",
        documentDate: "",
        createdDate: "",
        documentStatus: "",
        approvalStatus: "",
        reviewDate: "",
        remarks: "",
        reason: "",
      },
      UserArrayList: [],
      Checker1ArrayList: [],
      Checker2ArrayList: [],
      Consultant1ArrayList: [],
      Consultant2ArrayList: [],
      Approver1ArrayList: [],
      Approver2ArrayList: [],
      openAuthorList: false,
      openChecker1List: false,
      openChecker2List: false,
      openConsultant1List: false,
      openConsultant2List: false,
      openApprover1List: false,
      openApprover2List: false,
      searchAuthorList: [],
      searchCategory1List: [],
      searchCategory2List: [],
      fileTypes: [],
      userRole: "",
      currentPage: 1,
      perPage: 20,
      userId: 0,
      searchInputData: {
        docNo: "",
        docName: "",
        category1: "",
        category1Id: 0,
        category2: "",
        category2Id: 0,
        author: "",
        authorId: 0,
        documentStatus: "",
        approvalStatus: "",
        requestedDate: "",
        assignedFor: "",
      },
      isFormValid: true,
    };
  }
  componentDidMount() {
    let _this = this;
    let user = localStorage.getItem("UserId");
    let value = localStorage.getItem("Role");
    this.state.userId = user;
    this.state.currentUser = value;
    this.setState({}, () => {
      this.GetMyRequestsList();
    });
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }
  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }
    if (window.innerWidth < 315) {
      this.state.isCancelMobile = true;
    } else {
      this.state.isCancelMobile = false;
    }
    this.state.height = window.innerHeight;
    this.setState({});
  };
  GetMyRequestsList = (id) => {
    const { currentPage, perPage, userId } = this.state;
    let order = this.state.order === "asc" ? true : false;
    this.setState({ isRequestLoader: true, isRequestFailed: false });
    let apiUrl = `${API.GET_MYREQUESTS}?userId=${userId}&sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        pageNumber: parseInt(currentPage),
        pagesize: parseInt(perPage),
        documentId: 0,
        documentName: this.state.searchInputData.docName
          ? this.state.searchInputData.docName
          : null,
        documentNo: this.state.searchInputData.docNo
          ? this.state.searchInputData.docNo
          : null,
        category1Id: this.state.searchInputData.category1
          ? this.state.searchInputData.category1.value
          : 0,
        category1Name: this.state.searchInputData.category1
          ? this.state.searchInputData.category1.label
          : null,
        category2Id: this.state.searchInputData.category2
          ? this.state.searchInputData.category2.value
          : 0,
        category2Name: this.state.searchInputData.category2
          ? this.state.searchInputData.category2.label
          : null,
        documentStatus: this.state.searchInputData.documentStatus
          ? this.state.searchInputData.documentStatus
          : null,
        approvalStatus: this.state.searchInputData.approvalStatus
          ? this.state.searchInputData.approvalStatus
          : null,
        fileId: 0,
        fileName: null,
        fileType: null,
        authorId: this.state.searchInputData.author
          ? this.state.searchInputData.author.value
          : 0,
        authorName: this.state.searchInputData.author
          ? this.state.searchInputData.author.label
          : null,
        assignedFor: this.state.searchInputData.assignedFor
          ? this.state.searchInputData.assignedFor
          : null,
        fromDate: null,
        toDate: null,
        publishedDate: null,
        expiryDate: null,
        requestedDate: this.state.searchInputData.requestedDate
          ? moment(this.state.searchInputData.requestedDate).format(
            "YYYY-MM-DD"
          )
          : null,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.myrequestsList = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.state.requestCount = res.data.totalCount;
          this.setState({ isRequestFailed: false }, () => {
            this.GetCheckerList();
          });
        } else {
          this.setState({ isRequestLoader: false });
        }
      })
      .catch((error) => {
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        logoutFunction(error?.response?.status);
      });
  };
  GetVersionLogList = (id) => {
    let apiUrl = `${API.GET_VERSION_LOG}?docId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.versionLogList = res.data;
        this.setState({});
        this.setState({ isRequestLoader: false, isRequestFailed: false });
      }
    });
  };
  GetHistoryLogList = (id) => {
    let apiUrl = `${API.GET_HISTORY_LOG}?docId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.historyLogList = res.data;
        this.setState({});
      }
    });
  };
  GetApproveFileUrls = (id) => {
    const { userId } = this.state;
    let apiUrl = `${API.GET_ALL_FILES_URL}?docId=${id}&userId=${userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        pageNumber: 1,
        pageSize: 20,
      },
    }).then((res) => {
      if (res.status === 200) {
        this.state.approvefileurlList = res.data.values;
        this.setState({});
      }
    });
  };
  openFileDocument = (id) => {
    this.setState({ isRequestLoader: true, isRequestFailed: false });
    let apiUrl = `${API.GET_PARTICULAR_FILE_URL}?fileId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        window.open(res.data);
      }
    });
  };
  openURL = (url) => {
    window.open(url);
  };
  MyRequestDetails = (Id) => {
    this.setState({ isRequestLoader: true, isRequestFailed: false });
    let apiUrl = `${API.GET_MY_COMPLETED_TASK_PROPERTIES}?docId=${Id}`;
    let FilterArray = this.state.UserArrayList;
    var authorArray = [];
    var checker1Array = [];
    var checker2Array = [];
    var approver1Array = [];
    var approver2Array = [];
    var consultant1Array = [];
    var consultant2Array = [];
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          authorArray = FilterArray.filter(
            (item) => item.label === res.data.authorName
          );
          approver1Array = FilterArray.filter(
            (item) => item.label === res.data.approver1Name
          );
          approver2Array = FilterArray.filter(
            (item) => item.label === res.data.approver2Name
          );
          checker1Array = FilterArray.filter(
            (item) => item.label === res.data.checker1Name
          );
          checker2Array = FilterArray.filter(
            (item) => item.label === res.data.checker2Name
          );
          consultant1Array = FilterArray.filter(
            (item) => item.label === res.data.consultant1Name
          );
          consultant2Array = FilterArray.filter(
            (item) => item.label === res.data.consultant2Name
          );

          this.state.myrequestView = res.data;
          this.state.documentNumber = res.data.documentNumber;
          this.state.myrequestView.authorName = res.data.authorName
            ? authorArray.length !== 0
              ? Object.assign(
                {},
                ...authorArray?.map((item1) => {
                  return {
                    value: item1.value,
                    label: item1.label,
                  };
                })
              )
              : {
                label: res.data.authorName,
                value: res.data.adminAuthorId ? res.data.adminAuthorId : 0,
              }
            : "";
          this.state.myrequestView.authorId = res.data.adminAuthorId
            ? res.data.adminAuthorId
            : 0;
          this.state.myrequestView.approver1Name = res.data.approver1Name
            ? approver1Array.length !== 0
              ? Object.assign(
                {},
                ...approver1Array?.map((item1) => {
                  return {
                    value: item1.value,
                    label: item1.label,
                  };
                })
              )
              : {
                label: res.data.approver1Name,
                value: res.data.adminApprover1Id
                  ? res.data.adminApprover1Id
                  : 0,
              }
            : "";
          this.state.myrequestView.approver2Name = res.data.approver2Name
            ? approver2Array.length !== 0
              ? Object.assign(
                {},
                ...approver2Array?.map((item1) => {
                  return {
                    value: item1.value,
                    label: item1.label,
                  };
                })
              )
              : {
                label: res.data.approver2Name,
                value: res.data.adminApprover2Id
                  ? res.data.adminApprover2Id
                  : 0,
              }
            : "";
          this.state.myrequestView.checker1Name = res.data.checker1Name
            ? checker1Array.length !== 0
              ? Object.assign(
                {},
                ...checker1Array?.map((item1) => {
                  return {
                    value: item1.value,
                    label: item1.label,
                  };
                })
              )
              : {
                lebel: res.data.checker1Name,
                value: res.data.adminChecker1Id
                  ? res.data.adminChecker1Id
                  : 0,
              }
            : "";
          this.state.myrequestView.checker2Name = res.data.checker2Name
            ? checker2Array.length !== 0
              ? Object.assign(
                {},
                ...checker2Array?.map((item1) => {
                  return {
                    value: item1.value,
                    label: item1.label,
                  };
                })
              )
              : {
                label: res.data.checker2Name,
                value: res.data.adminChecker2Id
                  ? res.data.adminChecker2Id
                  : 0,
              }
            : "";
          this.state.myrequestView.consultant1Name = res.data.consultant1Name
            ? consultant1Array.length !== 0
              ? Object.assign(
                {},
                ...consultant1Array?.map((item1) => {
                  return {
                    value: item1.value,
                    label: item1.label,
                  };
                })
              )
              : {
                label: res.data.consultant1Name,
                value: res.data.adminConsultant1Id
                  ? res.data.adminConsultant1Id
                  : 0,
              }
            : "";
          this.state.myrequestView.consultant2Name = res.data.consultant2Name
            ? consultant2Array.length !== 0
              ? Object.assign(
                {},
                ...consultant2Array?.map((item1) => {
                  return {
                    value: item1.value,
                    label: item1.label,
                  };
                })
              )
              : {
                label: res.data.consultant2Name,
                value: res.data.adminConsultant2Id
                  ? res.data.adminConsultant2Id
                  : 0,
              }
            : "";
          this.state.myrequestView.approver1Id = res.data.adminApprover1Id
            ? res.data.adminApprover1Id
            : 0;
          this.state.myrequestView.approver2Id = res.data.adminApprover2Id
            ? res.data.adminApprover2Id
            : 0;
          this.state.myrequestView.checker1Id = res.data.adminChecker1Id
            ? res.data.adminChecker1Id
            : 0;
          this.state.myrequestView.checker2Id = res.data.adminChecker2Id
            ? res.data.adminChecker2Id
            : 0;
          this.state.myrequestView.consultant1Id = res.data.adminConsultant1Id
            ? res.data.adminConsultant1Id
            : 0;
          this.state.myrequestView.consultant2Id = res.data.adminConsultant2Id
            ? res.data.adminConsultant2Id
            : 0;
          this.state.myrequestView.documentStatus = res.data.documentStatus
            ? res.data.documentStatus
            : "";
          this.state.myrequestView.approvalStatus = res.data.approvalStatus
            ? res.data.approvalStatus
            : "";

          this.setState({}, () => {
            this.GetDropdownList();
            this.GetApproveFileUrls(this.state.myrequestView.id);
            this.GetHistoryLogList(this.state.myrequestView.id);
            this.GetVersionLogList(this.state.myrequestView.id);
          });
        }
      })
      .catch((error) => {
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        logoutFunction(error?.response?.status);
      });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  find = (e) => {
    this.setState({ isRequestLoader: true, isRequestFailed: false });
    this.state.perPage = e.value;
    const selectedPage = 1;
    this.state.currentPage = selectedPage;
    this.setState({}, () => {
      this.GetMyRequestsList();
    });
  };
  handlePageChange = (pageNumber) => {
    this.state.currentPage = pageNumber;
    this.setState({}, () => { });
    this.GetMyRequestsList();
  };
  Cancelrequest = () => {
    let cancelPopup = new window.bootstrap.Modal(
      document.getElementById("CancelRequestScreen")
    );
    cancelPopup.show();
    $("body").addClass("scrollhide");
  };
  closeCancelRequest = () => {
    $("body").removeClass("scrollhide");
  };
  Unobsoleterequest = () => {
    this.setState({ isRequestLoader: true, isRequestFailed: false });
    const { myrequestView, userId } = this.state;
    let data = {
      id: myrequestView.id,
      documentName: myrequestView.documentName,
      documentNo: this.state.documentNumber,
      reason: "",
    };
    let apiUrl = `${API.UNOBSOLETE_REQUESTS}?userId=${userId}`;
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((res) => {
        if (res.status === 200) {
          this.closeProperties();
          toast.success("Unobsoleted successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
          this.GetMyRequestsList();
        }
      })
      .catch((error) => {
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        logoutFunction(error?.response?.status);
      });
  };

  Submitrequest = () => {
    const { myrequestView, userId, userRole } = this.state;
    if (
      myrequestView?.approvalStatus?.toLowerCase() === "pending with author" ||
      myrequestView?.approvalStatus?.toLowerCase() === "pending with admin" ||
      myrequestView?.approvalStatus?.toLowerCase() === "registered"
    ) {
      this.Submitpendingadmin();
    } else if (
      myrequestView?.approvalStatus?.toLowerCase() === "pending with consultant"
    ) {
      this.submitpendingconsoltant();
    } else if (
      myrequestView?.approvalStatus?.toLowerCase() === "pending with checker"
    ) {
      this.submitpendingchecker();
    }
  };
  Submitpendingadmin = () => {
    const { myrequestView, userId, userRole } = this.state;
    this.state.myrequestView.checker1Id = this.state.myrequestView.checker1Name
      ? this.state.myrequestView.checker1Name.value
      : 0;
    this.state.myrequestView.checker2Id = this.state.myrequestView.checker2Name
      ? this.state.myrequestView.checker2Name.value
      : 0;
    this.state.myrequestView.approver1Id = this.state.myrequestView
      .approver1Name
      ? this.state.myrequestView.approver1Name.value
      : 0;
    this.state.myrequestView.approver2Id = this.state.myrequestView
      .approver2Name
      ? this.state.myrequestView.approver2Name.value
      : 0;
    this.state.myrequestView.consultant1Id = this.state.myrequestView
      .consultant1Name
      ? this.state.myrequestView.consultant1Name.value
      : 0;
    this.state.myrequestView.consultant2Id = this.state.myrequestView
      .consultant2Name
      ? this.state.myrequestView.consultant2Name.value
      : 0;
    this.state.myrequestView.createdDate = null;
    this.state.myrequestView.documentDate = null;
    this.state.myrequestView.reviewDate = null;
    this.setState({});

    if (myrequestView.checker1Id !== 0 && myrequestView.approver1Id !== 0) {
      let apiUrl = `${API.SUBMIT_REQUESTS}?userId=${userId}`;
      this.state.myrequestView.authorName = this.state.myrequestView.authorName
        ? this.state.myrequestView.authorName.label
        : "";
      this.state.myrequestView.checker1Name = this.state.myrequestView
        .checker1Name
        ? this.state.myrequestView.checker1Name.label
        : "";
      this.state.myrequestView.checker2Name = this.state.myrequestView
        .checker2Name
        ? this.state.myrequestView.checker2Name.label
        : "";
      this.state.myrequestView.approver1Name = this.state.myrequestView
        .approver1Name
        ? this.state.myrequestView.approver1Name.label
        : "";
      this.state.myrequestView.approver2Name = this.state.myrequestView
        .approver2Name
        ? this.state.myrequestView.approver2Name.label
        : "";
      this.state.myrequestView.consultant1Name = this.state.myrequestView
        .consultant1Name
        ? this.state.myrequestView.consultant1Name.label
        : "";
      this.state.myrequestView.consultant2Name = this.state.myrequestView
        .consultant2Name
        ? this.state.myrequestView.consultant2Name.label
        : "";
      this.state.myrequestView.documentNo = this.state.documentNumber;
      this.setState({ isRequestLoader: true, isRequestFailed: false });
      axios({
        method: "POST",
        url: apiUrl,
        data: myrequestView,
      })
        .then((res) => {
          if (res.status === 200) {
            document.getElementById("closePropertiesScreen").click();
            $(".offcanvas-backdrop").removeClass("show");
            $("body").removeClass("scrollhide");
            this.GetMyRequestsList();
            toast.success("Request edited successfully.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
            this.setState({
              approver1Error: false,
              checker1Error: false,
            });
          }
        })
        .catch((error) => {
          this.setState({ isRequestLoader: false, isRequestFailed: false });
          logoutFunction(error?.response?.status);
        });
    } else if (
      myrequestView.checker1Id === 0 &&
      myrequestView.approver1Id === 0
    ) {
      this.state.approver1Error = true;
      this.state.checker1Error = true;
      this.setState({});
    } else if (myrequestView.checker1Id === 0) {
      this.state.approver1Error = false;
      this.state.checker1Error = true;
      this.setState({});
    } else if (myrequestView.approver1Id === 0) {
      this.state.checker1Error = false;
      this.state.approver1Error = true;
      this.setState({});
    }
  };
  submitpendingconsoltant = () => {
    const { myrequestView, userId, userRole } = this.state;
    this.state.myrequestView.checker1Id = this.state.myrequestView.checker1Name
      ? this.state.myrequestView.checker1Name.value
      : 0;
    this.state.myrequestView.checker2Id = this.state.myrequestView.checker2Name
      ? this.state.myrequestView.checker2Name.value
      : 0;
    this.state.myrequestView.approver1Id = this.state.myrequestView
      .approver1Name
      ? this.state.myrequestView.approver1Name.value
      : 0;
    this.state.myrequestView.approver2Id = this.state.myrequestView
      .approver2Name
      ? this.state.myrequestView.approver2Name.value
      : 0;
    this.state.myrequestView.consultant1Id = this.state.myrequestView
      .consultant1Name
      ? this.state.myrequestView.consultant1Name.value
      : 0;
    this.state.myrequestView.consultant2Id = this.state.myrequestView
      .consultant2Name
      ? this.state.myrequestView.consultant2Name.value
      : 0;
    this.setState({});
    if (myrequestView.approver1Id !== 0) {
      let apiUrl = `${API.SUBMIT_REQUESTS}?userId=${userId}`;
      this.state.myrequestView.authorName = this.state.myrequestView.authorName
        ? this.state.myrequestView.authorName.label
        : "";
      this.state.myrequestView.checker1Name = this.state.myrequestView
        .checker1Name
        ? this.state.myrequestView.checker1Name.label
        : "";
      this.state.myrequestView.checker2Name = this.state.myrequestView
        .checker2Name
        ? this.state.myrequestView.checker2Name.label
        : "";
      this.state.myrequestView.approver1Name = this.state.myrequestView
        .approver1Name
        ? this.state.myrequestView.approver1Name.label
        : "";
      this.state.myrequestView.approver2Name = this.state.myrequestView
        .approver2Name
        ? this.state.myrequestView.approver2Name.label
        : "";
      this.state.myrequestView.consultant1Name = this.state.myrequestView
        .consultant1Name
        ? this.state.myrequestView.consultant1Name.label
        : "";
      this.state.myrequestView.consultant2Name = this.state.myrequestView
        .consultant2Name
        ? this.state.myrequestView.consultant2Name.label
        : "";
      this.state.myrequestView.documentNo = this.state.documentNumber;
      this.setState({ isRequestLoader: true, isRequestFailed: false });
      axios({
        method: "POST",
        url: apiUrl,
        data: myrequestView,
      })
        .then((res) => {
          if (res.status === 200) {
            // $("#propertiesScreen").removeClass("show");
            document.getElementById("closePropertiesScreen").click();
            $(".offcanvas-backdrop").removeClass("show");
            $("body").removeClass("scrollhide");
            this.GetMyRequestsList();
            toast.success("Request edited successfully.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
            this.setState({
              approver1Error: false,
            });
          }
        })
        .catch((error) => {
          this.setState({ isRequestLoader: false, isRequestFailed: false });
          logoutFunction(error?.response?.status);
        });
    } else if (myrequestView.approver1Id === 0) {
      this.state.approver1Error = true;
      this.setState({});
    }
  };
  submitpendingchecker = () => {
    const { myrequestView, userId, userRole } = this.state;
    this.state.myrequestView.consultant1Id = this.state.myrequestView
      .consultant1Name
      ? this.state.myrequestView.consultant1Name.value
      : 0;
    this.state.myrequestView.consultant2Id = this.state.myrequestView
      .consultant2Name
      ? this.state.myrequestView.consultant2Name.value
      : 0;
    this.state.myrequestView.checker1Id = this.state.myrequestView.checker1Name
      ? this.state.myrequestView.checker1Name.value
      : 0;
    this.state.myrequestView.checker2Id = this.state.myrequestView.checker2Name
      ? this.state.myrequestView.checker2Name.value
      : 0;
    this.state.myrequestView.approver1Id = this.state.myrequestView
      .approver1Name
      ? this.state.myrequestView.approver1Name.value
      : 0;
    this.state.myrequestView.approver2Id = this.state.myrequestView
      .approver2Name
      ? this.state.myrequestView.approver2Name.value
      : 0;
    this.setState({});

    if (myrequestView.approver1Id !== 0) {
      let apiUrl = `${API.SUBMIT_REQUESTS}?userId=${userId}`;
      this.state.myrequestView.authorName = this.state.myrequestView.authorName
        ? this.state.myrequestView.authorName.label
        : "";
      this.state.myrequestView.checker1Name = this.state.myrequestView
        .checker1Name
        ? this.state.myrequestView.checker1Name.label
        : "";
      this.state.myrequestView.checker2Name = this.state.myrequestView
        .checker2Name
        ? this.state.myrequestView.checker2Name.label
        : "";
      this.state.myrequestView.approver1Name = this.state.myrequestView
        .approver1Name
        ? this.state.myrequestView.approver1Name.label
        : "";
      this.state.myrequestView.approver2Name = this.state.myrequestView
        .approver2Name
        ? this.state.myrequestView.approver2Name.label
        : "";
      this.state.myrequestView.consultant1Name = this.state.myrequestView
        .consultant1Name
        ? this.state.myrequestView.consultant1Name.label
        : "";
      this.state.myrequestView.consultant2Name = this.state.myrequestView
        .consultant2Name
        ? this.state.myrequestView.consultant2Name.label
        : "";
      this.state.myrequestView.documentNo = this.state.documentNumber;
      this.setState({ isRequestLoader: true, isRequestFailed: false });
      axios({
        method: "POST",
        url: apiUrl,
        data: myrequestView,
      })
        .then((res) => {
          if (res.status === 200) {
            // $("#propertiesScreen").removeClass("show");
            document.getElementById("closePropertiesScreen").click();
            $(".offcanvas-backdrop").removeClass("show");
            $("body").removeClass("scrollhide");
            this.GetMyRequestsList();
            toast.success("Request edited successfully.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
            this.setState({
              approver1Error: false,
            });
          }
        })
        .catch((error) => {
          this.setState({ isRequestLoader: false, isRequestFailed: false });
          logoutFunction(error?.response?.status);
        });
    } else if (myrequestView.approver1Id === 0) {
      this.state.approver1Error = true;
      this.setState({});
    }
  };
  handleCancelPopup = () => {
    this.setState({ isRequestLoader: true, isRequestFailed: false });
    const { myrequestView, userId } = this.state;
    let data = {
      id: myrequestView.id,
      documentName: myrequestView.documentName,
      documentNo: this.state.documentNumber,
      reason: "",
    };
    let apiUrl = `${API.CANCEL_REQUEST}?userId=${userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((res) => {
        if (res.status === 200) {
          // $("#propertiesScreen").removeClass("show");
          document.getElementById("closePropertiesScreen").click();
          $(".offcanvas-backdrop").removeClass("show");
          $("body").removeClass("scrollhide");
          this.GetMyRequestsList();
          toast.success("Request cancelled successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((error) => {
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        logoutFunction(error?.response?.status);
      });
  };
  sortTable = (name) => {
    if (this.state.myrequestsList?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      this.state.currentPage = 1;
      this.setState({}, () => {
        this.GetMyRequestsList();
      });
    }
  };
  closeProperties = () => {
    // $("#propertiesScreen").removeClass("show");
    // document.getElementById("closePropertiesScreen").click();
    // $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    this.state.approver1Error = false;
    this.state.checker1Error = false;
    this.state.approver2Error = false;
    this.state.checker2Error = false;
    this.state.consultant1Error = false;
    this.state.consultant2Error = false;
    this.setState({});
  };
  bodycloseProperties = () => {
    if (window.location.pathname === "/myactions") {
      // $("#propertiesScreen").removeClass("show");
      document.getElementById("closePropertiesScreen").click();
      $(".offcanvas-backdrop").removeClass("show");
      $("body").removeClass("scrollhide");
      this.state.approver1Error = false;
      this.state.checker1Error = false;
      this.state.approver2Error = false;
      this.state.checker2Error = false;
      this.state.consultant1Error = false;
      this.state.consultant2Error = false;
      this.setState({});
    }
  };
  /* Autocomplete changes */
  GetCheckerList = () => {
    const { dispatch } = this.props;
    let apiUrl = `${API.GET_ALL_USERS}?includeAdmin=true`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          var FinalArray = res.data?.map((res) => {
            return {
              value: res.id,
              label: res.userName,
            };
          });
          dispatch({ type: "CheckerList", data: FinalArray });
          this.state.UserArrayList = FinalArray;
          this.state.Approver1ArrayList = FinalArray;
          this.state.Approver2ArrayList = FinalArray;
          this.state.Checker1ArrayList = FinalArray;
          this.state.Checker2ArrayList = FinalArray;
          this.state.Consultant1ArrayList = FinalArray;
          this.state.Consultant2ArrayList = FinalArray;
        }
        this.setState(
          { isRequestLoader: false, isRequestFailed: false },
          () => {
            this.GetAdminList();
            this.GetFileTypesList();
            this.GetCategory1();
          }
        );
      })
      .catch((error) => {
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        logoutFunction(error?.response?.status);
      });
  };
  GetDropdownList = () => {
    const { myrequestView } = this.state;
    let Array1 = this.state.UserArrayList;
    let Selectedvalues = [];
    let Checker1Value = [];
    let Checker2Value = [];
    let Consultant1Value = [];
    let Consultant2Value = [];
    let Approver1Value = [];
    let Approver2Value = [];
    let ArrayResult = [];
    let FilterArray = this.state.UserArrayList;
    ArrayResult.push(
      myrequestView.approver1Name,
      myrequestView.approver2Name,
      myrequestView.checker1Name,
      myrequestView.checker2Name,
      myrequestView.consultant1Name,
      myrequestView.consultant2Name,
      myrequestView.authorName
    );
    if (ArrayResult?.length !== 0) {
      ArrayResult?.map((j) => {
        if (j.label) {
          Selectedvalues.push(j.label);
        }
      });

      Selectedvalues?.map((i) => {
        FilterArray = FilterArray.filter((j) => j.label !== i);
      });
      Checker1Value = Array1.filter(
        (i) => i.label === myrequestView.checker1Name.label
      );
      Checker2Value = Array1.filter(
        (i) => i.label === myrequestView.checker2Name.label
      );
      Consultant1Value = Array1.filter(
        (i) => i.label === myrequestView.consultant1Name.label
      );
      Consultant2Value = Array1.filter(
        (i) => i.label === myrequestView.consultant2Name.label
      );
      Approver1Value = Array1.filter(
        (i) => i.label === myrequestView.approver1Name.label
      );
      Approver2Value = Array1.filter(
        (i) => i.label === myrequestView.approver2Name.label
      );

      let FinalApprover1Result = [...Approver1Value, ...FilterArray];
      let FinalApprover2Result = [...Approver2Value, ...FilterArray];
      let FinalChecker1Result = [...Checker1Value, ...FilterArray];
      let FinalChecker2Result = [...Checker2Value, ...FilterArray];
      let FinalConsultant1Result = [...Consultant1Value, ...FilterArray];
      let FinalConsultant2Result = [...Consultant2Value, ...FilterArray];

      this.state.Approver1ArrayList = FinalApprover1Result;
      this.state.Approver2ArrayList = FinalApprover2Result;
      this.state.Checker1ArrayList = FinalChecker1Result;
      this.state.Checker2ArrayList = FinalChecker2Result;
      this.state.Consultant1ArrayList = FinalConsultant1Result;
      this.state.Consultant2ArrayList = FinalConsultant2Result;
      this.setState({});
    }
  };
  handleSelectChange = (value, field) => {
    if (value) {
      this.state.myrequestView[field] = value;
      this.setState({}, () => {
        this.GetDropdownList();
      });
    } else {
      this.state.myrequestView[field] = "";
      this.setState({}, () => {
        this.GetDropdownList();
      });
    }
  };
  /* Common search */

  GetAdminList = () => {
    let apiUrl = `${API.GET_ALL_USERS}?includeAdmin=true`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.searchAuthorList = res.data.map((res) => {
          return {
            value: res.id,
            label: res.userName,
          };
        });
        this.setState({});
      }
    });
  };
  GetFileTypesList = () => {
    let apiUrl = `${API.GET_FILE_TYPE}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.fileTypes = res.data;
        this.setState({});
      }
    });
  };
  GetCategory1 = () => {
    let apiUrl = `${API.GET_CATAGORY_DROPDOWN}?type=category1&isLedger=false`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.searchCategory1List = res.data?.map((res) => {
          return {
            value: res.categoryId,
            label: res.categoryName,
          };
        });
        this.setState({});
      }
    });
  };
  GetCategory2 = (id) => {
    const { currentPage, perPage, userId } = this.state;
    let data = {
      pageNumber: parseInt(currentPage),
      pagesize: parseInt(perPage),
    };

    let apiUrl = `${API.GET_CATAGORY2}?category1Id=${id}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    }).then((res) => {
      if (res.status === 200) {
        this.state.searchCategory2List = res.data.values?.map((res) => {
          return {
            label: res.category2Name,
            value: res.category2Id,
          };
        });
        this.setState({});
      }
    });
  };
  handleChange = (e, field) => {
    if (field === "requestedDate") {
      const inputDate = e;
      this.state.searchInputData["requestedDate"] = inputDate;
      this.setState({}, () => { });
    } else {
      this.state.searchInputData[field] = e.target.value;
      this.setState({}, () => { });
    }
  };
  handleSearchSelectChange = (value, field) => {
    SelectedValueSearch = true;
    if (field === "category1") {
      if (value) {
        this.state.searchInputData[field] = value;
        this.state.searchInputData["category2"] = null;
        this.setState({}, () => {
          if (value?.value) {
            this.GetCategory2(value.value);
          }
        });
      } else {
        this.state.searchInputData[field] = "";
        this.state.searchInputData["category2"] = "";
        this.setState({});
      }
    } else {
      if (value) {
        this.state.searchInputData[field] = value;
      } else {
        this.state.searchInputData[field] = "";
      }
      this.setState({});
    }
  };
  OpenPendingSearch = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("pendingSearchScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar8");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  clearSearch = () => {
    this.state.searchInputData = {
      docNo: "",
      docName: "",
      category1: "",
      category1Id: 0,
      category2: "",
      category2Id: 0,
      author: "",
      authorId: 0,
      documentStatus: "",
      approvalStatus: "",
      requestedDate: "",
      assignedFor: "",
    };

    closeNewSearch = true;
    this.submitSearch();
  };

  closeSearch = () => {
    // $("#pendingSearchScreen").removeClass("show");
    document.getElementById("closeSearchButton").click();
    $("body").removeClass("scrollhide");
  };

  validatesubmitSearch = () => {
    const inputs = document.querySelectorAll(".my-input-class[required]");
    const filledInputs = Array.from(inputs).filter(
      (input) => input.value !== ""
    );
    const isInputValid = filledInputs?.length > 0;
    var isDateInput = false;
    if (this.state.searchInputData.requestedDate === "") {
      isDateInput = false;
    } else {
      isDateInput = true;
    }
    var category1Input = this.state.searchInputData.category1 ? true : false;
    var category2Input = this.state.searchInputData.category2 ? true : false;
    var authorInput = this.state.searchInputData.author ? true : false;
    const isValid =
      isInputValid ||
      isDateInput ||
      category2Input ||
      category1Input ||
      authorInput;
    if (isValid) {
      this.submitSearch();
    } else {
      this.setState({ isFormValid: false });
    }
  };
  submitSearch = () => {
    const { currentPage, perPage, userId } = this.state;
    this.setState({
      isRequestLoader: true,
      isRequestFailed: false,
      isFormValid: true,
    });
    let order = this.state.order === "asc" ? true : false;
    var searchDetails;

    if (closeNewSearch) {
      searchDetails = {
        pageNumber: 1,
        pagesize: perPage,
        documentId: 0,
        documentName: null,
        documentNo: null,
        category1Id: 0,
        category1Name: null,
        category2Id: 0,
        category2Name: null,
        documentStatus: null,
        approvalStatus: null,
        assignedFor: null,
        fileId: 0,
        fileName: null,
        fileType: null,
        authorId: 0,
        authorName: null,
        fromDate: null,
        toDate: null,
        publishedDate: null,
        expiryDate: null,
        requestedDate: null,
      };
    } else {
      searchDetails = {
        pageNumber: 1,
        pagesize: parseInt(perPage),
        documentId: 0,
        documentName: this.state.searchInputData.docName
          ? this.state.searchInputData.docName
          : null,
        documentNo: this.state.searchInputData.docNo
          ? this.state.searchInputData.docNo
          : null,
        category1Id: this.state.searchInputData.category1
          ? this.state.searchInputData.category1.value
          : 0,
        category1Name: this.state.searchInputData.category1
          ? this.state.searchInputData.category1.label
          : null,
        category2Id: this.state.searchInputData.category2
          ? this.state.searchInputData.category2.value
          : 0,
        category2Name: this.state.searchInputData.category2
          ? this.state.searchInputData.category2.label
          : null,
        documentStatus: this.state.searchInputData.documentStatus
          ? this.state.searchInputData.documentStatus
          : null,
        approvalStatus: this.state.searchInputData.approvalStatus
          ? this.state.searchInputData.approvalStatus
          : null,
        fileId: 0,
        fileName: null,
        fileType: null,
        authorId: this.state.searchInputData.author
          ? this.state.searchInputData.author.value
          : 0,
        authorName: this.state.searchInputData.author
          ? this.state.searchInputData.author.label
          : null,
        assignedFor: this.state.searchInputData.assignedFor
          ? this.state.searchInputData.assignedFor
          : null,
        fromDate: null,
        toDate: null,
        publishedDate: null,
        expiryDate: null,
        requestedDate: this.state.searchInputData.requestedDate
          ? moment(this.state.searchInputData.requestedDate).format(
            "YYYY-MM-DD"
          )
          : null,
      };
    }
    let apiUrl = `${API.GET_MYREQUESTS}?userId=${this.state.userId}&sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: searchDetails,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.currentPage = 1;
          this.state.myrequestsList = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.state.requestCount = res.data.totalCount;
          this.state.isRequestFailed = false;
          this.state.isRequestLoader = false;
          closeNewSearch = false;
          this.setState({}, () => {
            this.closeSearch();
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error("Failed to search. Please try again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        logoutFunction(error?.response?.status);
      });
  };

  render() {
    const {
      isMobile,
      isRequestFailed,
      isRequestLoader,
      isSmallMobile,
      iswebMobile,
      versionLogList,
      historyLogList,
      myrequestsList,
      currentPage,
      pageCount,
      perPage,
      myrequestView,
      isRadioMobile,
      requestCount,
      approvedocumentsList,
      approvefileurlList,
      currentUser,
      sortBy,
      order,
      Approver1ArrayList,
      Approver2ArrayList,
      Checker1ArrayList,
      Checker2ArrayList,
      Consultant1ArrayList,
      Consultant2ArrayList,
      openauthorList,
      opencategory1List,
      opencategory2List,
      fileTypes,
      searchAuthorList,
      searchCategory1List,
      searchCategory2List,
      isFormValid,
    } = this.state;
    // const {
    //   isFavoriteFailed, isFavoriteLoader, openauthorList, opencategory1List, opencategory2List, fileTypes,searchAuthorList, searchCategory1List, searchCategory2List, isFormValid, isMobile, isSmallMobile, favouriteCount, favouritePropertiesList, favouritesList, favouriteArryList, addcategoryValue, currentPage, isCategory2EditHide, isCategory2AddHide, isCategory2DeleteHide, perPage, editcategoryValue, isRadioMobile, currentUser, sortBy, order
    // } = this.state;
    let {
      classes,
      actionCommonSearchResult,
      requestCommonSearchResult,
      menuToggle,
      CheckerList,
    } = this.props;
    return (
      <>
        {$("#propertiesScreen").hasClass("show") ||
          $("#pendingSearchScreen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        <div
          className={`${isMobile
              ? "main-body-mobile"
              : menuToggle
                ? "menu-main-body"
                : "main-body"
            } `}
        >
          {isRequestLoader && (
            <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
          )}

          {isRequestFailed && (
            <div className="spinner_overlay">
              <div className="loader">
                <span>Loading failed</span>
              </div>
            </div>
          )}

          {isMobile == true ? (
            <div className="head-fixed">
              <div className="mobile-head border-bottom w-100">
                <div className="col-12 mobile-title d-flex">
                  {UserRole.ADMIN === currentUser
                    ? "Document requests"
                    : "My completed tasks"}{" "}
                  <label className="rejectedstatus-color d-flex ms-1">
                    <span>(</span>
                    <span className="pending">{requestCount}</span>
                    <span>)</span>
                  </label>
                </div>
              </div>
              <div
                className={`${isMobile ? "common-mobiletable-style" : "common-table-style"
                  }`}
              >
                <div
                  className={`col-12 d-flex justify-content-start border-bottom table-responsive ${isMobile ? "pl-1" : isSmallMobile ? "" : "pl-10"
                    } `}
                >
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="90%"></td>
                        <td width="10%" className="text-end">
                          <button
                            className={`displaybutton ${isRadioMobile ? "pe-3" : ""
                              } ${isSmallMobile ? "pe-3" : ""} ${this.state.isCancelMobile ? "pe-3" : ""
                              }`}
                            id="displaybuttoncolor"
                            onClick={() => this.OpenPendingSearch()}
                          >
                            <img
                              src={Filter}
                              style={{ marginTop: "-4px" }}
                            ></img>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div className="head-fixed">
              <div className="title">
                {UserRole.ADMIN === currentUser ? (
                  <>
                    <img src={MyRequestIcon} />
                    <span className="pl-10 head-span mt-10 d-flex">
                      Document requests{" "}
                      <label className="rejectedstatus-color d-flex ms-1">
                        <span className="p-0">(</span>
                        <span className="pending p-0">{requestCount}</span>
                        <span className="p-0">)</span>
                      </label>
                    </span>
                  </>
                ) : (
                  <>
                    <img src={CompletedTaskIcon} />
                    <span className="pl-10 head-span mt-10 d-flex">
                      My completed tasks{" "}
                      <label className="rejectedstatus-color d-flex ms-1">
                        <span className="p-0">(</span>
                        <span className="pending p-0">{requestCount}</span>
                        <span className="p-0">)</span>
                      </label>
                    </span>
                  </>
                )}
              </div>
              <div
                className={`${isMobile
                    ? "mobile-search"
                    : menuToggle
                      ? " sidemenu-search"
                      : "web-search"
                  }`}
              >
                <table width="100%">
                  <tbody>
                    <tr>
                      <td width="90%"></td>
                      <td width="10%" className="text-end">
                        <button
                          className={`displaybutton ${isRadioMobile ? "pr-0" : ""
                            } ${isSmallMobile ? "pl-0" : ""}`}
                          id="displaybuttoncolor"
                          onClick={() => this.OpenPendingSearch()}
                        >
                          <img src={Filter} style={{ marginTop: "-4px" }}></img>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <ToastContainer limit={1} />
          <div
            className={`${isMobile ? "pending-mobile-table " : "pending-table1 "
              }table-responsive  table-fixed-header table-responsive-height`}
            style={{ width: "100%" }}
          >
            <table className="table fileListTable2 table-borderless table-hover">
              <thead className="thead-sticky  thead-color">
                <tr>
                  <td></td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("documentNo")}
                  >
                    <span> Document no. </span>
                    {sortBy === "documentNo" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("documentName")}
                  >
                    <span>Document name </span>
                    {sortBy === "documentName" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("authorName")}
                  >
                    <span> Author </span>
                    {sortBy === "authorName" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("category1Name")}
                  >
                    <span> Category 1 </span>
                    {sortBy === "category1Name" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("category2Name")}
                  >
                    <span> Category 2 </span>
                    {sortBy === "category2Name" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  {UserRole.ADMIN === currentUser ? (
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("documentStatus")}
                    >
                      <span>Document status </span>
                      {sortBy === "documentStatus" && (
                        <img
                          src={order === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                  ) : (
                    <></>
                  )}
                  {UserRole.ADMIN === currentUser ||
                    UserRole.REVIEWER === currentUser ? (
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("approvalStatus")}
                    >
                      <span>Approval status </span>
                      {sortBy === "approvalStatus" && (
                        <img
                          src={order === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                  ) : (
                    <></>
                  )}
                  {UserRole.REVIEWER === currentUser ? (
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("assignedFor")}
                    >
                      <span> Assigned for </span>
                      {sortBy === "assignedFor" && (
                        <img
                          src={order === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                  ) : (
                    <></>
                  )}
                  {UserRole.ADMIN === currentUser ||
                    UserRole.REVIEWER === currentUser ? (
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("requestedDate")}
                    >
                      <span>Requested date/time </span>
                      {sortBy === "requestedDate" && (
                        <img
                          src={order === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                  ) : (
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("requestedDate")}
                    >
                      <span>Assigned date/time</span>
                      {sortBy === "requestedDate" && (
                        <img
                          src={order === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                  )}
                  <td></td>{" "}
                </tr>
              </thead>
              <tbody>
                {myrequestsList?.length !== 0 ? (
                  myrequestsList?.map((item, index) => (
                    <tr
                      id={"active" + item.id}
                      key={index}
                      className="requestRadioSelect"
                    >
                      <td></td>
                      <td onClick={() => this.MyRequestDetails(item.id)}>
                        <span>
                          <a
                            className="properties-view tableoverflowNo hoverUnderline"
                            title={item.documentNo}
                          >
                            {item.documentNo}
                          </a>
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflowNo"
                          title={item.documentName}
                        >
                          {" "}
                          {item.documentName}{" "}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflow1"
                          title={item.authorName}
                        >
                          {item.authorName}{" "}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflow1"
                          title={item.category1Name}
                        >
                          {item.category1Name}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflow1"
                          title={item.category2Name}
                        >
                          {" "}
                          {item.category2Name}
                        </span>
                      </td>
                      {UserRole.ADMIN === currentUser ? (
                        <td
                          className={`fw-600 ${item?.documentStatus?.toLowerCase() ===
                              "published" ||
                              item?.documentStatus?.toLowerCase() ===
                              "republished"
                              ? "activestatus-color"
                              : item.documentStatus === "Obsolete" ||
                                item.documentStatus === "Not started" ||
                                item?.documentStatus?.toLowerCase() ===
                                "expired"
                                ? "rejectedstatus-color"
                                : "expire20-color"
                            }`}
                        >
                          <span
                            className="tableoverflow1"
                            title={item.documentStatus}
                          >
                            {item.documentStatus}
                          </span>{" "}
                        </td>
                      ) : (
                        <></>
                      )}
                      {UserRole.ADMIN === currentUser ||
                        UserRole.REVIEWER === currentUser ? (
                        <td
                          className={`fw-600 ${item?.approvalStatus?.toLowerCase() ===
                              "approved" ||
                              item?.approvalStatus?.toLowerCase() ===
                              "republished"
                              ? "activestatus-color"
                              : item.approvalStatus === "Obsolete" ||
                                item.approvalStatus === "Not started" ||
                                item?.documentStatus?.toLowerCase() ===
                                "expired"
                                ? "rejectedstatus-color"
                                : "expire20-color"
                            }`}
                        >
                          <span
                            className="tableoverflowStatus"
                            title={item.approvalStatus}
                          >
                            {item.approvalStatus}
                          </span>{" "}
                        </td>
                      ) : (
                        <></>
                      )}
                      {UserRole.REVIEWER === currentUser ? (
                        <td>
                          <span
                            className="tableoverflow1"
                            title={item.assignedFor}
                          >
                            {" "}
                            {item.assignedFor}
                          </span>
                        </td>
                      ) : (
                        <></>
                      )}
                      <td>
                        <span className="tableoverflowDate">
                          {item.requestedDate
                            ? moment(
                              new Date(Date.parse(item.requestedDate))
                            ).format("DD-MMM-YYYY h:mm A")
                            : ""}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    {UserRole.REVIEWER === currentUser ? (
                      <td colSpan={9} className="table-nodata">
                        {myrequestsList && "No record found"}
                      </td>
                    ) : (
                      <td colSpan={8} className="table-nodata">
                        {myrequestsList && "No record found"}
                      </td>
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div
            className={`${isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : menuToggle
                  ? "common-submenu sidemenu-pagination"
                  : "common-submenu web-pagination"
              } pb-2 pt-2`}
          >
            {myrequestsList?.length !== 0 ? (
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="8%" className="p-3">
                      <div
                        className={`${this.state.iswebMobile
                            ? "mobilePageSelect"
                            : "webpageSelect"
                          }`}
                      >
                        <Select
                          options={paginglist}
                          defaultValue={paginglistDefault}
                          classNamePrefix="paging"
                          isSearchable={false}
                          menuPlacement={"top"}
                          menuPosition={"fixed"}
                          onChange={(e) => this.find(e)}
                        />
                      </div>
                    </td>
                    <td
                      width="92%"
                      className={`text-end ${this.state.isCancelMobile ? "pagination-padd" : "p-3"
                        }`}
                    >
                      {this.state.isMobile ? (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={1}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      ) : (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={3}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : null}
          </div>
        </div>
        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="propertiesScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
              }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title head-span">
              {myrequestView.documentNo}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : ""
                }`}
              style={{ backgroundColor: "white" }}
              id="closePropertiesScreen"
              data-bs-dismiss="offcanvas"
              onClick={() => this.closeProperties()}
            >
              <img src={CrossIcon} className="cursor-pointer app-image-hover" />
            </button>{" "}
          </div>

          <div className="offcanvas-body px-4 pt-0" id="viewbar">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={NewPropertiesIcon} />{" "}
                    <span className="pl-10 properties-span">Document no.</span>
                    &nbsp;
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    title={myrequestView.documentNo}
                  >
                    {myrequestView.documentNo
                      ? myrequestView.documentNo
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={SearchFileIcon} />{" "}
                    <span className="pl-10 properties-span mt-1">
                      Document name
                    </span>
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    title={myrequestView.documentName}
                  >
                    {myrequestView.documentName
                      ? myrequestView.documentName
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={AssignIcon} />{" "}
                    <span className="pl-7 properties-span">Author</span>
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    title={myrequestView.authorName.label}
                  >
                    {myrequestView.authorName.label
                      ? myrequestView.authorName.label
                      : ""}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={NewPropertiesIcon} />{" "}
                    <span className="pl-7 properties-span">Version</span>&nbsp;
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    title={myrequestView.version}
                  >
                    {myrequestView.version ? myrequestView.version : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={SubCategoryIcon} />{" "}
                    <span className="pl-10 properties-span">Category 1</span>
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    title={myrequestView.category1Name}
                  >
                    {myrequestView.category1Name
                      ? myrequestView.category1Name
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={SubCategoryIcon} />{" "}
                    <span className="pl-10 properties-span">Category 2</span>
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    title={myrequestView.category2Name}
                  >
                    {myrequestView.category2Name
                      ? myrequestView.category2Name
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={DateIcon} />{" "}
                    <span className="pl-10 properties-span">
                      Registered date
                    </span>
                  </label>
                  <label
                    className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                  >
                    {myrequestView.createdDate
                      ? moment(myrequestView.createdDate).format("DD-MMM-YYYY")
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={DateIcon} />{" "}
                    <span className="pl-10 properties-span">Expiry date</span>
                  </label>
                  <label
                    className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                  >
                    {myrequestView.reviewDate
                      ? moment(myrequestView.reviewDate).format("DD-MMM-YYYY")
                      : ""}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2  ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={NewPropertiesIcon} />{" "}
                    <span className="pl-10 properties-span">
                      {" "}
                      Document status
                    </span>
                  </label>
                  {myrequestView?.documentStatus?.toLowerCase() ===
                    "published" ||
                    myrequestView?.documentStatus?.toLowerCase() === "approved" ||
                    myrequestView?.documentStatus?.toLowerCase() ===
                    "republished" ? (
                    <label
                      className={`properties-label Propertiestext-overflow activestatus-color ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      title={myrequestView.documentStatus}
                    >
                      {myrequestView.documentStatus}
                    </label>
                  ) : myrequestView?.documentStatus?.toLowerCase() ===
                    "expired" ||
                    myrequestView?.documentStatus?.toLowerCase() ===
                    "obsolete" ? (
                    <label
                      className={`properties-label  rejectedstatus-color ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      title={myrequestView.documentStatus}
                    >
                      {myrequestView.documentStatus}
                    </label>
                  ) : (
                    <label
                      className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      style={{ color: "#EC930D" }}
                      title={myrequestView.documentStatus}
                    >
                      {myrequestView.documentStatus}
                    </label>
                  )}
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2  ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={NewPropertiesIcon} />{" "}
                    <span className="pl-10 properties-span">
                      {" "}
                      Approval status
                    </span>
                  </label>
                  {myrequestView?.approvalStatus?.toLowerCase() ===
                    "approved" ||
                    myrequestView?.approvalStatus?.toLowerCase() ===
                    "published" ||
                    myrequestView.approvalStatus.toLowerCase() ===
                    "republished" ? (
                    <label
                      className={`properties-label Propertiestext-overflow activestatus-color ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      title={myrequestView.approvalStatus}
                    >
                      {myrequestView.approvalStatus}
                    </label>
                  ) : myrequestView.approvalStatus.toLowerCase() ===
                    "obsolete" ||
                    myrequestView?.approvalStatus?.toLowerCase() ===
                    "expired" ||
                    myrequestView.approvalStatus.toLowerCase() ===
                    "not started" ? (
                    <label
                      className={`properties-label Propertiestext-overflow rejectedstatus-color ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      title={myrequestView.approvalStatus}
                    >
                      {myrequestView.approvalStatus}
                    </label>
                  ) : (
                    <label
                      className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      style={{ color: "#EC930D" }}
                      title={myrequestView.approvalStatus}
                    >
                      {myrequestView.approvalStatus}
                    </label>
                  )}
                </div>
              </div>
              {(UserRole.ADMIN === currentUser &&
                myrequestView?.approvalStatus?.toLowerCase() === "approved") ||
                (UserRole.ADMIN === currentUser &&
                  myrequestView?.approvalStatus?.toLowerCase() === "obsolete") ? (
                <>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">Checker 1</span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.checker1Name.label}
                      >
                        {myrequestView.checker1Name.label
                          ? myrequestView.checker1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">Checker 2</span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.checker2Name.label}
                      >
                        {myrequestView.checker2Name.label
                          ? myrequestView.checker2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">
                          Consultant 1
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.consultant1Name.label}
                      >
                        {myrequestView.consultant1Name.label
                          ? myrequestView.consultant1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">
                          Consultant 2
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.consultant2Name.label}
                      >
                        {myrequestView.consultant2Name.label
                          ? myrequestView.consultant2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">Approver 1</span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.approver1Name.label}
                      >
                        {myrequestView.approver1Name.label
                          ? myrequestView.approver1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">Approver 2</span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.approver2Name.label}
                      >
                        {myrequestView.approver2Name.label
                          ? myrequestView.approver2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                </>
              ) : (UserRole.ADMIN === currentUser) &
                (myrequestView?.approvalStatus?.toLowerCase() ===
                  "registered") ||
                (UserRole.ADMIN === currentUser) &
                (myrequestView?.approvalStatus?.toLowerCase() ===
                  "pending with author") ||
                (UserRole.ADMIN === currentUser) &
                (myrequestView?.approvalStatus?.toLowerCase() ===
                  "pending with admin") ? (
                <>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text required ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Checker 1
                      </span>
                    </label>
                    <div
                      className={`${this.state.checker1Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.checker1Name}
                        options={Checker1ArrayList}
                        defaultValue={myrequestView.checker1Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "checker1Name")
                        }
                      />
                    </div>
                    {this.state.checker1Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Checker 2
                      </span>
                    </label>
                    <div
                      className={`${this.state.checker2Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.checker2Name}
                        options={Checker2ArrayList}
                        defaultValue={myrequestView.checker2Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "checker2Name")
                        }
                      />
                    </div>
                    {this.state.checker2Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Consultant 1
                      </span>
                    </label>
                    <div
                      className={`${this.state.consultant1Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.consultant1Name}
                        options={Consultant1ArrayList}
                        defaultValue={myrequestView.consultant1Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "consultant1Name")
                        }
                      />
                    </div>
                    {this.state.consultant1Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Consultant 2
                      </span>
                    </label>
                    <div
                      className={`${this.state.consultant2Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.consultant2Name}
                        options={Consultant2ArrayList}
                        defaultValue={myrequestView.consultant2Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "consultant2Name")
                        }
                      />
                    </div>
                    {this.state.consultant2Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text required ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Approver 1
                      </span>
                    </label>
                    <div
                      className={`${this.state.approver1Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.approver1Name}
                        options={Approver1ArrayList}
                        defaultValue={myrequestView.approver1Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "approver1Name")
                        }
                      />
                    </div>
                    {this.state.approver1Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Approver 2
                      </span>
                    </label>
                    <div
                      className={`${this.state.approver2Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.approver2Name}
                        options={Approver2ArrayList}
                        defaultValue={myrequestView.approver2Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "approver2Name")
                        }
                      />
                    </div>
                    {this.state.approver2Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : UserRole.ADMIN === currentUser &&
                myrequestView?.approvalStatus?.toLowerCase() ===
                "pending with consultant" ? (
                <>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img
                          className="properties-search-img"
                          src={AssignIcon}
                        />{" "}
                        <span className="pl-10 properties-search-span">
                          Checker 1
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.checker1Name.label}
                      >
                        {myrequestView.checker1Name.label
                          ? myrequestView.checker1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img
                          className="properties-search-img"
                          src={AssignIcon}
                        />{" "}
                        <span className="pl-10 properties-search-span">
                          {" "}
                          Checker 2{" "}
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.checker2Name.label}
                      >
                        {myrequestView.checker2Name.label
                          ? myrequestView.checker2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">
                          Consultant 1
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.consultant1Name.label}
                      >
                        {myrequestView.consultant1Name.label
                          ? myrequestView.consultant1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">
                          Consultant 2
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.consultant2Name.label}
                      >
                        {myrequestView.consultant2Name.label
                          ? myrequestView.consultant2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text required ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Approver 1
                      </span>
                    </label>
                    <div
                      className={`${this.state.approver1Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.approver1Name}
                        options={Approver1ArrayList}
                        defaultValue={myrequestView.approver1Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "approver1Name")
                        }
                      />
                    </div>
                    {this.state.approver1Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Approver 2
                      </span>
                    </label>
                    <div
                      className={`${this.state.approver2Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.approver2Name}
                        options={Approver2ArrayList}
                        defaultValue={myrequestView.approver2Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "approver2Name")
                        }
                      />
                    </div>
                    {this.state.approver2Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : UserRole.ADMIN === currentUser &&
                myrequestView?.approvalStatus?.toLowerCase() ===
                "pending with approver" ? (
                <>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img
                          className="properties-search-img"
                          src={AssignIcon}
                        />{" "}
                        <span className="pl-10 properties-search-span">
                          Checker 1
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.checker1Name.label}
                      >
                        {myrequestView.checker1Name.label
                          ? myrequestView.checker1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img
                          className="properties-search-img"
                          src={AssignIcon}
                        />{" "}
                        <span className="pl-10 properties-search-span">
                          Checker 2
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.checker2Name.label}
                      >
                        {myrequestView.checker2Name.label
                          ? myrequestView.checker2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img
                          className="properties-search-img"
                          src={AssignIcon}
                        />{" "}
                        <span className="pl-10 properties-search-span">
                          Consultant 1
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.consultant1Name.label}
                      >
                        {myrequestView.consultant1Name.label
                          ? myrequestView.consultant1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img
                          className="properties-search-img"
                          src={AssignIcon}
                        />{" "}
                        <span className="pl-10 properties-search-span">
                          Consultant 2
                        </span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.consultant2Name.label}
                      >
                        {myrequestView.consultant2Name.label
                          ? myrequestView.consultant2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">Approver 1</span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.approver1Name.label}
                      >
                        {myrequestView.approver1Name.label
                          ? myrequestView.approver1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">Approver 2</span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.approver2Name.label}
                      >
                        {myrequestView.approver2Name.label
                          ? myrequestView.approver2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                </>
              ) : UserRole.ADMIN === currentUser &&
                myrequestView?.approvalStatus?.toLowerCase() ===
                "pending with checker" ? (
                <>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">Checker 1</span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.checker1Name.label}
                      >
                        {myrequestView.checker1Name.label
                          ? myrequestView.checker1Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={AssignIcon} />{" "}
                        <span className="pl-7 properties-span">Checker 2</span>
                      </label>
                      <label
                        className={`properties-label Propertiestext-overflow ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        title={myrequestView.checker2Name.label}
                      >
                        {myrequestView.checker2Name.label
                          ? myrequestView.checker2Name.label
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        {" "}
                        Consultant 1
                      </span>
                    </label>
                    <div
                      className={`${this.state.consultant1Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.consultant1Name}
                        options={Consultant1ArrayList}
                        defaultValue={myrequestView.consultant1Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "consultant1Name")
                        }
                      />
                    </div>
                    {this.state.consultant1Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Consultant 2
                      </span>
                    </label>
                    <div
                      className={`${this.state.consultant2Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.consultant2Name}
                        options={Consultant2ArrayList}
                        defaultValue={myrequestView.consultant2Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "consultant2Name")
                        }
                      />
                    </div>
                    {this.state.consultant2Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text required ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        Approver 1
                      </span>
                    </label>
                    <div
                      className={`${this.state.approver1Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.approver1Name}
                        options={Approver1ArrayList}
                        defaultValue={myrequestView.approver1Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "approver1Name")
                        }
                      />
                    </div>
                    {this.state.approver1Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}
                  >
                    <label
                      className={`d-flex m-0 mb-2 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-search-img" src={AssignIcon} />{" "}
                      <span className="pl-10 properties-search-span">
                        {" "}
                        Approver 2
                      </span>
                    </label>
                    <div
                      className={`${this.state.approver2Error === true ? "border-red" : ""
                        }`}
                    >
                      <Select
                        className={`text-12-normal`}
                        classNamePrefix="assigngroups"
                        value={myrequestView.approver2Name}
                        options={Approver2ArrayList}
                        defaultValue={myrequestView.approver2Name || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          this.handleSelectChange(e, "approver2Name")
                        }
                      />
                    </div>
                    {this.state.approver2Error === true ? (
                      <span className="send-rework-label">
                        This field is required
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : (
                <></>
              )}
              {UserRole.REVIEWER === currentUser ? (
                <>
                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={SearchFileIcon} />{" "}
                        <span className="pl-7 properties-span mt-1">Files</span>
                      </label>
                      <div className="row">
                        {approvefileurlList?.length !== 0 ? (
                          approvefileurlList?.map((j, index) => (
                            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 pr-0">
                              {j.fileType !== "url" ? (
                                <label
                                  className={`cursor-pointer url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                                    }`}
                                  onClick={() => this.openFileDocument(j.id)}
                                >
                                  <FileIcon
                                    fileName={j.fileName}
                                    style={{ width: "15px" }}
                                  />
                                  <span className="pl-7 text-center urlspan">
                                    {j.fileName}
                                  </span>
                                </label>
                              ) : (
                                ""
                              )}
                            </div>
                          ))
                        ) : (
                          <>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                              <label className="table-noversion"> - </label>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <img className="properties-img" src={URLIcon} />{" "}
                        <span className="pl-7 properties-span">URLs</span>
                      </label>
                      <div className="row">
                        {approvefileurlList?.length !== 0 ? (
                          approvefileurlList?.map((j, index) => (
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                              {j.fileType === "url" ? (
                                <label
                                  className={`cursor-pointer url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                                    }`}
                                  onClick={() => this.openURL(j.fileName)}
                                >
                                  <img
                                    src={URLworldIcon}
                                    style={{ width: "17px" }}
                                  />
                                  <span className="pl-7 text-center urlspan">
                                    {j.fileName}
                                  </span>
                                </label>
                              ) : (
                                ""
                              )}
                            </div>
                          ))
                        ) : (
                          <>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                              <label className="table-noversion"> - </label>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                  } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={NotesIcon} />{" "}
                    <span className="pl-10 properties-span mt-1">Notes</span>
                  </label>
                  <label
                    className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                  >
                    {myrequestView.remarks ? myrequestView.remarks : " - "}
                  </label>
                </div>
              </div>
            </div>

            <div className="row mt-1">
              {(UserRole.ADMIN === currentUser &&
                myrequestView?.approvalStatus?.toLowerCase() === "approved") ||
                (UserRole.ADMIN === currentUser &&
                  myrequestView?.approvalStatus?.toLowerCase() ===
                  "pending with approver") ? (
                <div
                  className={`${iswebMobile ? "col-12" : "col-6"
                    } col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-3  ${isMobile ? "mt-4" : "mt-2"
                    }`}
                >
                  <button
                    className={`btn btn-light input-group offcavasclose filter-reworkbtn p-2`}
                    onClick={() => this.Cancelrequest()}
                  >
                    <img
                      src={ButtonCancelRequestIcon}
                      className="modal-img"
                    ></img>
                    <span className="send-rework-label pl-5">
                      Cancel request
                    </span>
                  </button>
                </div>
              ) : UserRole.ADMIN === currentUser &&
                myrequestView?.approvalStatus?.toLowerCase() === "obsolete" ? (
                <div
                  className={`${iswebMobile ? "col-12" : "col-6"
                    } col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-3  ${isMobile ? "mt-4" : "mt-2"
                    }`}
                >
                  <button
                    className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                    onClick={() => this.Unobsoleterequest()}
                  >
                    <img src={ButtonUnobsoleteIcon} className="modal-img"></img>
                    <span className="model-label pl-5">Unobsolete</span>
                  </button>
                </div>
              ) : (UserRole.ADMIN === currentUser &&
                myrequestView?.approvalStatus?.toLowerCase() ===
                "pending with checker") ||
                (UserRole.ADMIN === currentUser &&
                  myrequestView?.approvalStatus?.toLowerCase() ===
                  "pending with consultant") ||
                (UserRole.ADMIN === currentUser &&
                  myrequestView?.approvalStatus?.toLowerCase() ===
                  "registered") ||
                (UserRole.ADMIN === currentUser &&
                  myrequestView?.approvalStatus?.toLowerCase() ===
                  "pending with author") ||
                (UserRole.ADMIN === currentUser &&
                  myrequestView?.approvalStatus?.toLowerCase() ===
                  "pending with admin") ? (
                <>
                  <div
                    className={`${this.state.isCancelMobile ? "col-12" : "d-flex"
                      }`}
                  >
                    <button
                      className={`btn btn-light input-group offcavasclose filter-reworkbtn p-2`}
                      onClick={() => this.Cancelrequest()}
                    >
                      <img
                        src={ButtonCancelRequestIcon}
                        className="modal-img"
                      ></img>
                      <span className="send-rework-label pl-5">
                        Cancel request
                      </span>
                    </button>

                    <button
                      className={`btn btn-light input-group offcavasclose filter-nextbtn p-2 ml-2 ${this.state.isCancelMobile ? "mt-2" : "ml-10"
                        } border border-1 border-danger`}
                      onClick={() => this.Submitrequest()}
                    >
                      <img src={ButtonSubmitIcon} className="modal-img"></img>
                      <span style={{ marginTop: "3px" }} className="model-label pl-5">Submit</span>
                    </button>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>

            {UserRole.ADMIN === currentUser ? (
              <div className="row mt-1">
                <div
                  className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <img className="properties-img" src={VersionIcon} />{" "}
                      <span className="pl-10 properties-span">Versions</span>
                    </label>
                    <div className="table-responsive mb-4 mt-3">
                      <table id="versionTable" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th
                              className={`${isSmallMobile ? "Author-width" : ""
                                }`}
                            >
                              Versions
                            </th>
                            <th
                              className={`${isSmallMobile ? "Author-width" : ""
                                }`}
                            >
                              Author
                            </th>
                            <th
                              className={`${isSmallMobile ? "Publisheddate-width" : ""
                                } no-wrap`}
                            >
                              Published date/time
                            </th>
                            <th
                              className={`${isSmallMobile ? "Author-width" : ""
                                }`}
                            >
                              Checker
                            </th>
                            <th
                              className={`${isSmallMobile ? "Author-width" : ""
                                }`}
                            >
                              Approver
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {versionLogList?.length !== 0 ? (
                            versionLogList?.map((i, index) => (
                              <tr id={index} key={index}>
                                <td className="no-wrap">{i.documentVersion}</td>
                                <td className="no-wrap">{i.authorName}</td>
                                <td className="no-wrap">
                                  {i.publishedDate
                                    ? moment(
                                      new Date(Date.parse(i.publishedDate))
                                    ).format("DD-MMM-YYYY h:mm A")
                                    : ""}
                                </td>
                                <td className="no-wrap">{i.checkerName}</td>
                                <td className="no-wrap">{i.approverName}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="table-noversion" colSpan={5}>
                                No version history
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="row mt-1">
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                      }`}
                  >
                    <img className="properties-img" src={VersionIcon} />{" "}
                    <span className="pl-10 properties-span">History log</span>
                  </label>
                  <div className="table-responsive mb-4 mt-3">
                    <table id="historyTable" style={{ width: "100%" }}>
                      <tbody>
                        {historyLogList?.length !== 0 ? (
                          historyLogList?.map((i, index) => (
                            <>
                              <tr id={index} key={index}>
                                <th className="title-width">{i.status}</th>
                                <td
                                  className={`history-date ${isRadioMobile ? "date-width" : ""
                                    }`}
                                >
                                  {" "}
                                  {i.createdDate
                                    ? moment(
                                      new Date(Date.parse(i.createdDate))
                                    ).format("DD-MMM-YYYY h:mm A")
                                    : ""}
                                </td>
                              </tr>
                              <tr>
                                <th colSpan={2}>
                                  {i.reviewer + " " + "(" + i.type + ")"}
                                </th>
                              </tr>
                              <tr>
                                <td colSpan={2} className="history-comment">
                                  {i.comments}
                                </td>
                              </tr>
                            </>
                          ))
                        ) : (
                          <tr>
                            <td className="table-noversion" colSpan={3}>
                              No history log to display
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade modal-style"
          id="CancelRequestScreen"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header pb-2 pl-20">
                <h5
                  className="modal-title d-flex pl-10"
                  id="exampleModalLongTitle"
                >
                  <img src={WarningIcon} />
                  &nbsp;<span className="mt-1 pl-5"></span>Warning
                </h5>
              </div>
              <div className="modal-body pl-20">
                <h5 className="warning-text">
                  {" "}
                  Are you sure you want to cancel the request ?
                </h5>
                <span className="app-label">
                  {" "}
                  The information about the request will be removed.
                </span>
              </div>
              <div className="modal-footer border-top-none justify-content-center pb-3">
                <button
                  className={`btn btn-light input-group  d-flex ${isMobile ? "warning-btn-mobile p-1" : "warning-btn"
                    } `}
                  data-bs-dismiss="modal"
                  onClick={() => this.closeCancelRequest()}
                >
                  <span className="rejectedstatus-color pl-10">No</span>{" "}
                </button>
                <button
                  className={`btn btn-light input-group d-flex ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                    }`}
                  data-bs-dismiss="modal"
                  onClick={() => this.handleCancelPopup()}
                >
                  <span style={{ fontSize: "14px" }} className="model-label pl-10">Yes</span>{" "}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Common search */}
        <div
          className="offcanvas offcanvas-end offcanvaspendingStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="pendingSearchScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
              }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              Search
            </h6>
            <button
              className={`text-reset offcavasclose  buttonstyle ${isMobile ? "pr-0" : "pr-0"
                }`}
              data-bs-dismiss="offcanvas"
              id="closeSearchButton"
              onClick={() => this.closeSearch()}
              style={{ backgroundColor: "white" }}
            >
              <img src={CrossIcon} className="cursor-pointer app-image-hover" />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 pt-0" id="viewbar8">
            <div className="row">
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <span>
                    <img src={infoBlack} alt="" /> Document no.
                  </span>
                </div>
                <input
                  style={{ fontSize: "12px" }}
                  value={this.state.searchInputData.docNo}
                  onChange={(e) => this.handleChange(e, "docNo")}
                  maxLength={255}
                  className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                  required
                />
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <img src={file} alt="" />
                  <span> Document name</span>
                </div>
                <input
                  style={{ fontSize: "12px" }}
                  value={this.state.searchInputData.docName}
                  onChange={(e) => this.handleChange(e, "docName")}
                  maxLength={255}
                  className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                  required
                />
              </div>

              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle mb-2 commonsearch-field">
                  <img src={SubCategoryIcon} alt="" />
                  <span> Category 1</span>
                </div>
                <Select
                  className="text-12-normal"
                  classNamePrefix="assigngroups"
                  value={this.state.searchInputData.category1}
                  options={searchCategory1List}
                  defaultValue={
                    this.state.searchInputData.category1 || "Select"
                  }
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    this.handleSearchSelectChange(value, "category1")
                  }
                />
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle mb-2 commonsearch-field">
                  <img src={SubCategoryIcon} alt="" />
                  <span> Category 2</span>
                </div>
                <Select
                  className="text-12-normal"
                  classNamePrefix="assigngroups"
                  value={this.state.searchInputData.category2}
                  options={searchCategory2List}
                  isDisabled={!this.state.searchInputData.category1}
                  defaultValue={
                    this.state.searchInputData.category2 || "Select"
                  }
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    this.handleSearchSelectChange(value, "category2")
                  }
                />
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle mb-2 commonsearch-field">
                  <img src={AssignIcon} alt="" />
                  <span> Author</span>
                </div>
                <Select
                  className="text-12-normal"
                  classNamePrefix="assigngroups"
                  value={this.state.searchInputData.author}
                  options={searchAuthorList}
                  defaultValue={this.state.searchInputData.author || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    this.handleSearchSelectChange(value, "author")
                  }
                />
              </div>
              {UserRole.ADMIN === currentUser && (
                <div className="col-sm-6 col-12 mt-2 mb-2">
                  <div className="inputTitle commonsearch-field">
                    <img src={infoBlack} alt="" />
                    <span>Document status</span>
                  </div>
                  <input
                    style={{ fontSize: "12px" }}
                    value={this.state.searchInputData.documentStatus}
                    maxLength={255}
                    onChange={(e) => this.handleChange(e, "documentStatus")}
                    className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                    required
                  />
                </div>
              )}
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <img src={infoBlack} alt="" />
                  <span>Approval status</span>
                </div>
                <input
                  style={{ fontSize: "12px" }}
                  value={this.state.searchInputData.approvalStatus}
                  maxLength={255}
                  onChange={(e) => this.handleChange(e, "approvalStatus")}
                  className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                  required
                />
              </div>
              {UserRole.REVIEWER === currentUser && (
                <div className="col-sm-6 col-12 mt-2 mb-2">
                  <div className="inputTitle commonsearch-field">
                    <img src={infoBlack} alt="" />
                    <span>Assigned For</span>
                  </div>
                  <input
                    style={{ fontSize: "12px" }}
                    value={this.state.searchInputData.assignedFor}
                    maxLength={255}
                    onChange={(e) => this.handleChange(e, "assignedFor")}
                    className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                    required
                  />
                </div>
              )}
              <div
                className="col-sm-6 col-12 mt-2 mb-2"
                style={{ marginTop: "12px" }}
              >
                <div className="inputTitle date-bottom2 commonsearch-field">
                  <img src={calender} alt="" />
                  <span>Requested date </span>
                </div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    className="form-control f-12 mt-search dropdown-height"
                    emptyLabel="dd-mmm-yyyy"
                    keyboardIcon={<img src={dateIcon} />}
                    format="dd-MMM-yyyy"
                    value={
                      this.state.searchInputData.requestedDate
                        ? this.state.searchInputData.requestedDate
                        : null
                    }
                    size="small"
                    onChange={(e) => this.handleChange(e, "requestedDate")}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>

            {!isFormValid && (
              <p style={{ color: "red" }}>At least one field is mandatory</p>
            )}

            <div className="button" style={{ display: "flex" }}>
              <button id="edit2" onClick={() => this.clearSearch()}>
                <span className="clear-icon-position">✕</span>
                <span>Clear</span>
              </button>
              <button id="edit" onClick={() => this.validatesubmitSearch()}>
                <img
                  style={{
                    marginTop: "-4px",
                    marginRight: "4px",
                    width: "14px",
                  }}
                  src={search}
                  alt=""
                />
                Search
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    requestCommonSearchResult: state.commonReducer.requestCommonSearchResult,
    actionCommonSearchResult: state.commonReducer.actionCommonSearchResult,
    ApproverList: state.commonReducer.ApproverList,
    ConsultantList: state.commonReducer.ConsultantList,
    CheckerList: state.commonReducer.CheckerList,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyRequest)
);
